import Vue from 'vue';
import AsyncScript from '../mixins/AsyncScript';
import BuildUrl from '../mixins/BuildUrl';
import GetMediaQuery from '../mixins/GetMediaQuery';
import PreventScroll from '../mixins/PreventScroll';
import UserAgent from '../mixins/UserAgent';

if (process.browser) {
  Vue.mixin(AsyncScript);
  Vue.mixin(PreventScroll);
}

Vue.mixin(BuildUrl);
Vue.mixin(GetMediaQuery);
Vue.mixin(UserAgent);